import { useContext } from 'react';

import { BannerStatus } from 'ui-components/components/banner-message/banner-enums';
import { BannerMessageV2 } from 'ui-components/components/banner-message/banner-message-v2';

import { AddFundErrorMessage } from './error-message';
import style from './styles.module.css';
import { PhoneVerificationContext } from '../../../../../components/phone-verification/context';
import { useWalletRegistrationErrorContext } from '../../../../../wallet/modals/wallet-registration/contexts/wallet-registration-error-context';
import { PHONE_VERIFICATION } from '../../../../../wallet/utilities/constants';
import { useAddFundsContext } from '../../context/add-funds-context-provider';

/**
 *
 * @param {object} props
 * @param {string} props.currencyCode
 * @param {Array} [props.errors]
 * @returns {JSX.Element}
 */
export const AddFundsErrorSection = ({ currencyCode, errors = [] }) => {
  const { autoFundErrors = [] } = useAddFundsContext();
  const { errors: walletErrors = [] } = useWalletRegistrationErrorContext();
  const errorMessages = walletErrors?.map((err) => err.Message);
  const { providerIdRequiringPhoneVerification } = useContext(PhoneVerificationContext) || {};
  const isPhoneVerificationError = errorMessages && errorMessages.some((v) => v?.includes(PHONE_VERIFICATION));
  const hasErrors =
    (autoFundErrors?.length > 0 || walletErrors?.length > 0 || errors?.length > 0) &&
    !providerIdRequiringPhoneVerification &&
    !isPhoneVerificationError;

  if (!hasErrors) {
    return null;
  }
  const allErrors = new Set([...walletErrors, ...autoFundErrors, ...errors]);
  return (
    <div className={style['error-banner']}>
      <BannerMessageV2
        className={style['error-message']}
        content={
          <ul className={style['error-message-items']}>
            {[...allErrors]?.map((error, index) => {
              return <AddFundErrorMessage key={index} currencyCode={currencyCode} error={error} />;
            })}
          </ul>
        }
        status={BannerStatus.Error}
      />
    </div>
  );
};
